import { HttpErrorResponse } from '@angular/common/http';
import { AUTH_ENTRY_URL } from '@core/auth/auth-entry.constants';
import { SessionUser } from '@core/auth/auth-session.model';
import { syncActiveCompanyFromUser } from '@core/tenant/tenant-company.utils';
import { TenantContextService } from '@core/tenant/tenant-context.service';

export type CompanyRequiredRedirect =
  | { kind: 'none' }
  | { kind: 'auth-entry' }
  | { kind: 'onboard' }
  | { kind: 'choose-workspace' }
  | { kind: 'dashboard' };

/**
 * Decide destino tras 422 «Compania requerida».
 * Solo mandar al wizard si el usuario confirmado no tiene compañías.
 */
export function resolveCompanyRequiredRedirect(
  isAuthenticated: boolean,
  user: SessionUser | null | undefined,
  tenantContext: TenantContextService
): CompanyRequiredRedirect {
  if (!isAuthenticated) {
    return { kind: 'auth-entry' };
  }
  if (user == null) {
    return { kind: 'none' };
  }
  if (user.companies.length === 0) {
    return { kind: 'onboard' };
  }
  syncActiveCompanyFromUser(tenantContext, user);
  if (user.companies.length > 1) {
    return { kind: 'choose-workspace' };
  }
  return { kind: 'dashboard' };
}

export function companyRequiredRedirectPath(
  redirect: CompanyRequiredRedirect
): readonly string[] | null {
  switch (redirect.kind) {
    case 'auth-entry':
      return AUTH_ENTRY_URL;
    case 'onboard':
      return ['/onboard'];
    case 'choose-workspace':
      return ['/authentication/choose-workspace'];
    case 'dashboard':
      return ['/dashboard'];
    default:
      return null;
  }
}

/** @internal tests */
export function isCompanyRequiredHttpError(error: HttpErrorResponse): boolean {
  const payload = error.error as { error?: string } | null;
  return error.status === 422 && payload?.error === 'Compania requerida';
}
